export default {
    deliver: 'تسليم',
    receive: 'استلام',
    'remaining-samples': 'المواد المتبقية'
}